import { inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { RouteStore } from 'bernie-core';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialog } from 'components/common/disclaimer-dialog';

const LinkTracked = ClickTracker(Link);

export interface ReviewDisclaimerTriggerProps extends LocalizedComponentProps {
  routeStore?: RouteStore;
  countMessage: string;
  reviewDisclaimer?: string;
}

@withLocalization
@inject('routeStore')
export class ReviewsDisclaimerTrigger extends React.Component<ReviewDisclaimerTriggerProps> {
  private disclaimerTrigger;

  constructor(props) {
    super(props);

    this.onDisclaimerDialogClose = this.onDisclaimerDialogClose.bind(this);
  }

  private onDisclaimerDialogClose() {
    this.props.routeStore.goBack();

    if (this.disclaimerTrigger && typeof this.disclaimerTrigger.focus === 'function') {
      this.disclaimerTrigger.focus();
    }
  }

  public render() {
    const { countMessage, routeStore, reviewDisclaimer } = this.props;
    const { formatText } = this.props.l10n;
    const dialogId = 'reviewDisclaimerDialog';
    const dialogQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialogNested: dialogId });

    const triggerRef = disclaimerTrigger => {
      this.disclaimerTrigger = disclaimerTrigger;
    };

    return (
      <React.Fragment>
        <UitkMoreInfoTrigger className="all-t-padding-one all-b-padding-four">
          <LinkTracked
            linkName="Review Disclaimer Dialog"
            rfrr=".Reviews.DisclaimerDialog"
            to={{ pathname: routeStore.pathname, search: dialogQuery }}
            innerRef={triggerRef}
          >
            {countMessage}
            <UitkIcon
              name="info_outline"
              size={UitkIconSize.EXTRA_SMALL}
              id="review-disclaimer-information-icon"
              title={formatText('hotels.infosite.reviews.verifiedReviews.disclaimerIcon.title')}
            />
          </LinkTracked>
        </UitkMoreInfoTrigger>
        {reviewDisclaimer && (
          <DisclaimerDialog
            dialogId={dialogId}
            dialogType="pwaDialogNested"
            disclaimerText={reviewDisclaimer}
            handleClose={this.onDisclaimerDialogClose}
            innerHTML={true}
            layerId="review-disclaimer-dialog"
            disclaimerTextId="review-disclaimer-text"
          />
        )}
      </React.Fragment>
    );
  }
}
